import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { factory, Input, Text, useProps, useStyles } from '@coveord/plasma-mantine';
import { Locales } from '../../strings/Locales.js';
var renderValue = function renderValue(value) {
    if (value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0) {
        return /*#__PURE__*/ _jsx(Text, {
            c: "dimmed",
            children: Locales.format('ValueWithLabel.notApplicableLabel')
        });
    } else if (typeof value === 'string') {
        return /*#__PURE__*/ _jsx(Text, {
            c: "gray.7",
            children: value
        });
    } else if (Array.isArray(value) && value.every(function(v) {
        return typeof v === 'string';
    })) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: value.map(function(val) {
                return /*#__PURE__*/ _jsx(Text, {
                    c: "gray.7",
                    children: val
                }, val);
            })
        });
    } else {
        throw 'Not implemented';
    }
};
var defaultProps = {
    readOnlyFormatter: renderValue
};
export var ValueWithLabel = factory(function(_props, ref) {
    var _useProps = useProps('ViewFieldWrapper', defaultProps, _props), classNames = _useProps.classNames, styles = _useProps.styles, style = _useProps.style, className = _useProps.className, vars = _useProps.vars, readOnlyFormatter = _useProps.readOnlyFormatter, value = _useProps.value, label = _useProps.label, others = _object_without_properties(_useProps, [
        "classNames",
        "styles",
        "style",
        "className",
        "vars",
        "readOnlyFormatter",
        "value",
        "label"
    ]);
    var getStyles = useStyles({
        name: 'ViewFieldWrapper',
        classes: {},
        vars: vars,
        classNames: classNames,
        className: className,
        style: style,
        props: _props,
        styles: styles
    });
    return /*#__PURE__*/ _jsx(Input.Wrapper, _object_spread_props(_object_spread({
        ref: ref,
        label: label
    }, others, getStyles('root', {
        style: style,
        styles: styles,
        className: className,
        classNames: classNames
    })), {
        children: readOnlyFormatter(value)
    }));
});

//# sourceMappingURL=ValueWithLabel.js.map